var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAffordable({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 48.5,
    fill: "#D5E5EF",
    stroke: "#173372",
    strokeWidth: 3
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_4809)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67 38.25H55.6667V27L67 38.25ZM55.6667 41.0625H67V67.7812C67 70.1112 65.0972 72 62.75 72H37.25C34.9028 72 33 70.1104 33 67.7812V31.2188C33 28.8888 34.9028 27 37.25 27H52.8333L52.8337 38.25C52.8333 39.8057 54.0995 41.0625 55.6667 41.0625ZM38.6667 34.7344C38.6667 35.1193 38.9881 35.4375 39.375 35.4375H46.4583C46.8479 35.4375 47.1667 35.1193 47.1667 34.7344V33.3281C47.1667 32.944 46.8479 32.625 46.4583 32.625H39.375C38.9881 32.625 38.6667 32.944 38.6667 33.3281V34.7344ZM39.375 41.0625H46.4583C46.8479 41.0625 47.1667 40.7461 47.1667 40.3594V38.9531C47.1667 38.5664 46.8479 38.25 46.4583 38.25H39.375C38.9881 38.25 38.6667 38.5664 38.6667 38.9531V40.3594C38.6667 40.7461 38.9881 41.0625 39.375 41.0625ZM50.487 54.8437L49.9203 54.7031C47.9016 54.0879 47.9458 53.7275 48.0167 53.4111C48.1384 52.7245 49.4856 52.5569 50.6968 52.741C51.1921 52.8151 51.7354 52.9881 52.2543 53.1667C53.1742 53.4826 54.1871 52.9964 54.5077 52.0821C54.8286 51.1646 54.3402 50.1626 53.4159 49.8436C52.7768 49.6252 52.2552 49.4851 51.7726 49.3801V48.7969C51.7726 47.8274 50.9799 47.0391 50.0018 47.0391C49.0237 47.0391 48.2309 47.8274 48.2309 48.7969V49.3235C46.2458 49.7461 44.8469 50.9766 44.5281 52.8135C43.8724 56.5787 47.4668 57.6255 49.0012 58.0729L49.5159 58.2212C52.1084 58.9573 52.0659 59.2047 51.9879 59.6521C51.8662 60.3387 50.519 60.509 49.3042 60.3222C48.6899 60.2316 47.9044 59.9514 47.2093 59.7043L46.8137 59.5615C45.8919 59.2456 44.8808 59.7207 44.5541 60.6355C44.2289 61.5504 44.7118 62.555 45.6343 62.8793L46.012 63.0112C46.6989 63.2563 47.4623 63.5025 48.2308 63.6714V64.2656C48.2308 65.2351 49.0236 66.0234 50.0017 66.0234C50.9798 66.0234 51.7725 65.2351 51.7725 64.2656V63.716C53.7523 63.2947 55.1557 62.0873 55.4762 60.2504C56.1359 56.4434 52.4615 55.3975 50.487 54.8437Z",
    fill: "#173372"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_4809"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 45,
    fill: "white",
    transform: "translate(33 27)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAffordable);
export default __webpack_public_path__ + "static/media/affordable.865bcdb9df8ae9105b754e74b4d2ee03.svg";
export { ForwardRef as ReactComponent };